export default __webpack_public_path__ + "assets/b20aff218c5ea82a7e9c53c8eec2eb1a.jpg";